export const MEDIA_TYPES = {
  SPARK_VIDEOS: 'SparkVideos',
  PANDAVIDEOS: 'Pandavideos',
  EMBED: 'Embed',
  MOVIIE: 'Moviie',
}

// Planilhas não são renderizáveis na área de membros: caem no card do
// NotSupported, que já oferece o download por padrão.
export const SPREADSHEET_FILE_EXTS = ['.xls', '.xlsm', '.xlsx', '.csv']

// Word também não tem preview: o mesmo card do NotSupported entrega o download.
export const WORD_FILE_EXTS = ['.doc', '.docx']

// Extensões que a área de membros nunca renderiza embutidas — o conteúdo é
// entregue só por download, no layout padrão do NotSupported.
export const DOWNLOAD_ONLY_FILE_EXTS = [
  ...SPREADSHEET_FILE_EXTS,
  ...WORD_FILE_EXTS,
]

export function isDownloadOnlyFileExt(fileExt?: string | null) {
  if (!fileExt) return false
  return DOWNLOAD_ONLY_FILE_EXTS.includes(fileExt.toLowerCase())
}

// Sandbox policy for rendering creator-supplied embed HTML ("HTML livre").
// Includes allow-same-origin: nested provider iframes (YouTube, etc.) inherit
// the sandbox's flags and fail to play without it. Trade-off: top-level
// script in the pasted HTML now runs in this app's real origin instead of an
// opaque one, so treat "HTML livre" as a trusted-authors-only surface.
export const EMBED_SANDBOX =
  'allow-scripts allow-same-origin allow-popups allow-presentation allow-forms'

// Sandbox policy for an <iframe src> pasted inside lesson HTML (aula tipo Texto
// com embed de Thinglink, YouTube, Google Forms...). Unlike EMBED_SANDBOX above
// this frames a REMOTE document, so allow-same-origin only gives the frame back
// its OWN origin (the provider's) — never ours. allow-forms is needed by
// interactive embeds (forms, quizzes); allow-top-navigation is deliberately
// omitted so a pasted embed can't drive app navigation.
export const HTML_IFRAME_SANDBOX =
  'allow-scripts allow-same-origin allow-popups allow-presentation allow-forms'
